<template>
  <div>
    <h4>社會科</h4>
    <dl>
      <dt>二下社會班</dt>
      <dd>
        國二下社會科難度較高，尤其是中國地理學生容易遇到瓶頸，因此高僑特別開設國二下社會班，解決你社會科的疑難雜症！
      </dd>

      <dt>國三社會班</dt>
      <dd>
        國三社會班教授國三社會科以及三年的社會科總複習。社會科是需要記憶的科目，到會考前一次做統整把記憶都找回來，讓觀念更清晰，解題更有邏輯！
      </dd>
    </dl>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/scss/course.scss";
</style>
